import React from 'react'

import { useNavigate } from 'react-router-dom'

import LocalStorageService from '../../services/LocalStorageService'


// Font Awesome

// Appt Components
import Anchor from '../../components/simple/anchor/Anchor'
import Box from '../../components/simple/box/Box'
import Text from '../../components/simple/text/Text'

import ResponsiveGrid from '../../components/compound/responsiveGrid/ResponsiveGrid'

// Shared Components
import BreadcrumbBar from '../shared/BreadcrumbBar'
import ActionBoxLarge from '../../components/compound/actionBox/ActionBoxLarge'

function AILanding (props) {
  const navigate = useNavigate()

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const activeUser = LocalStorageService.get('userDetails')
  const terms = LocalStorageService.get('terms');


  return (
    <>
      <BreadcrumbBar
        title="AI Insights"
        path={
          <>
            <Anchor href="/">BehaviourSmart</Anchor>
            <Text color="besmartBlue" size="xsmall">
              {window.location.pathname}
            </Text>
          </>
        }
      />    
      <Box background='white' direction='column' gap='small' round='small' flex='grow' margin={{ top: 'medium', bottom: 'small' }}>
        <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
            <Text size="xlarge" weight="bold" color='secondary'>
                Behaviour Smart AI Insights
            </Text>
        </Box>
    </Box>

      {/* {(aiResponse || aiError) && <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'medium' }}
        >
        <Text size="large" style={{ width: '100%'}}>{availableActions[selectedAction]}</Text>

          <Text margin={{ top: 'xsmall' }} size="xlarge">
            {aiResponse && <>
                <Text style={{ whiteSpace: 'pre-line' }}>{aiResponse}</Text>
            </>}
            {aiError && <Text color='red'>There was an error processing your request. Please try again.</Text>}
          </Text>
        </Box>
      </Box>} */}

      <ResponsiveGrid
        rows={['auto']}
        columns={{
          small: ['auto'],
          medium: ['33%', '33%', '33%'],
          large: ['33%', '33%', '33%'],
          xlarge: ['33%', '33%', '33%'],
        }}
        gap="small"
      >



        <ActionBoxLarge
            title={'Incident'}
            description={'View insights on a particular incident'}
            onClick={() => navigate('/ai/insights/incident')}
        />

        <ActionBoxLarge
            title={terms?.serviceUser?.charAt(0)?.toUpperCase() + terms?.serviceUser?.slice(1)}
            description={`View insights on a particular ${terms.serviceUser || "service user"}`}
            onClick={() => navigate('/ai/insights/serviceuser/')}
        />

        <ActionBoxLarge
            title={terms?.service?.charAt(0)?.toUpperCase() + terms?.service?.slice(1)}
            description={`View insights on a particular ${terms.service || "service"}`}
            onClick={() => navigate('/ai/insights/service/')}
        />
      </ResponsiveGrid>
    </>
  );
}

export default AILanding
